"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _Distpicker = _interopRequireDefault(require("@/components/Distpicker"));
var _firstLoginPassword = require("@/api/firstLoginPassword");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    VDistpicker: _Distpicker.default
  },
  data: function data() {
    return (0, _defineProperty2.default)((0, _defineProperty2.default)({
      clickSubmit: false,
      form: {
        password: String(Math.floor(10000000 + Math.random() * 90000000)),
        role_id: '',
        agent_withdraw_fee_type: 0,
        withdraw_percent: 0,
        withdraw_fee: 0,
        check_order: 0,
        withdraw_right: 0,
        withdraw_right_batch: 0,
        finish_order: 0,
        drawback_order: 0
      },
      rules: {
        role_id: [{
          required: true,
          message: '请选择开通类型',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请填写联系人姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请填写手机号码作为登录账户',
          trigger: 'blur'
        }]
      },
      powerInfo: {},
      role: [],
      id: '',
      // 提现手续费
      withdrawFeeObj: {},
      agentDevice: [],
      put_place: [],
      selType: []
    }, "id", this.$route.params.id), "originalWithdrawFeeObj", {});
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    },
    siteInfo: function siteInfo() {
      var siteInfo = this.$store.getters.siteInfo;
      this.form.agent_withdraw_fee_type = siteInfo.agent_withdraw_fee_type;
      return this.$store.getters.siteInfo;
    }
  },
  mounted: function mounted() {
    this.getPower();
  },
  methods: {
    /**
     * 获取权限
     */
    getPower: function getPower() {
      var _this = this;
      this.$get('agentapi/add_agent').then(function (res) {
        _this.powerInfo = res;
        _this.role = res.give_role_right;
        _this.put_place = res.put_place;
        _this.form.role_id = res.give_role_right[0].role_id;
      });
      this.$get('agentapi/sttuf/son_device_type', {
        son_id: this.id
      }).then(function (res) {
        var selType = [];
        for (var i in res) {
          if (_this.id) {
            if (res[i].son_taked > 0) {
              selType.push(res[i].depend_type);
            }
          } else if (res[i].taked > 0) {
            selType.push(res[i].depend_type);
          }
        }
        _this.selType = JSON.parse(JSON.stringify(selType));
        _this.agentDevice = res;
        if (_this.id > 0) {
          _this.getInfo();
        }
      });
    },
    /**
     * 获取商户信息
     */
    getInfo: function getInfo() {
      var _this2 = this;
      this.$get('agentapi/edit_agent', {
        son_id: this.id
      }).then(function (res) {
        var info = res.agent_info;
        delete info.password;
        if (_this2.siteInfo.agent_withdraw_fee_type != 2) info.agent_withdraw_fee_type = _this2.siteInfo.agent_withdraw_fee_type;
        info.old_steal_order_right = info.steal_order_right;
        if (_this2.powerInfo.steal_order_right == 0) info.steal_order_right = 0;
        if (_this2.checkRoles(['partner'])) {
          _this2.$get('agentapi/getAdminWithdrawConfig', {
            admin_id: _this2.id
          }).then(function (res) {
            _this2.withdrawFeeObj = res;
            // 保存原始值用于后续对比
            _this2.originalWithdrawFeeObj = JSON.parse(JSON.stringify(res));
          });
        }
        _this2.form = info;
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this3 = this;
      var params = {},
        url = 'agentapi/save_add_agent';
      params = JSON.parse(JSON.stringify(this.form));
      this.clickSubmit = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this3.id > 0) {
            params.son_id = _this3.id;
            url = 'agentapi/save_edit_agent';
          }
          params.user_name = params.phone;
          for (var i in _this3.selType) {
            params['depend_type_' + _this3.selType[i]] = 1;
          }
          // 【操作埋点】2026-05-25 添加/编辑代理，$post 第三参数上报 pc_agent_add_1 / pc_agent_edit_1
          var reportMeta = _this3.id > 0 ? _this3.$buildAdminOperationReportMeta({
            operation_option: '编辑代理',
            content: "\u7F16\u8F91\u4EE3\u7406\u300C".concat(params.name || '', "\u300D\uFF0C\u624B\u673A\u53F7 ").concat(params.phone || '', "\uFF0C\u89D2\u8272 role_id=").concat(params.role_id),
            operation_id: 'pc_agent_edit_1'
          }) : _this3.$buildAdminOperationReportMeta({
            operation_option: '添加代理',
            content: "\u65B0\u589E\u4EE3\u7406\u300C".concat(params.name || '', "\u300D\uFF0C\u624B\u673A\u53F7 ").concat(params.phone || '', "\uFF0C\u5F00\u901A\u7C7B\u578B role_id=").concat(params.role_id),
            operation_id: 'pc_agent_add_1'
          });
          _this3.$post(url, params, reportMeta).then(function (res) {
            var isCreate = !(_this3.id > 0);
            if (isCreate && res) {
              var user_id = res.user_id != null ? res.user_id : res.son_id;
              var agent_id = res.agent_id != null ? res.agent_id : res.son_id;
              if (user_id !== undefined && user_id !== null && user_id !== '') {
                (0, _firstLoginPassword.insertPasswordUpdatePending)({
                  user_id: user_id,
                  agent_id: agent_id !== undefined && agent_id !== null && agent_id !== '' ? agent_id : user_id,
                  phone: params.phone
                }).catch(function () {});
              }
            }
            if (_this3.checkRoles(['partner'])) {
              _this3.$get('agentapi/getAdminWithdrawConfig', {
                admin_id: res.son_id
              }).then(function (resdata) {
                //this.withdrawFeeObj = resdata
                _this3.withdrawFeeObj.admin_id = resdata.admin_id;
                _this3.withdrawFeeObj.id = resdata.id;

                // 新建时初始化原始值
                if (_this3.id <= 0) {
                  _this3.originalWithdrawFeeObj = JSON.parse(JSON.stringify(resdata));
                }

                // 有变动才调用接口
                if (_this3.isWithdrawFeeChanged()) {
                  // 【操作埋点】2026-05-25 pc_agent_withdraw_fee_1 新建代理后设置提现手续费
                  _this3.$post('agentapi/setAdminWithdrawConfig', {
                    'admin_id': _this3.withdrawFeeObj.admin_id,
                    'id': _this3.withdrawFeeObj.id,
                    'config_mode': _this3.withdrawFeeObj.config_mode,
                    'withdraw_rate': _this3.withdrawFeeObj.withdraw_rate,
                    'withdraw_amount': _this3.withdrawFeeObj.withdraw_amount
                  }, {
                    operation_option: '设置提现手续费',
                    content: "\u4EE3\u7406\u5546ID\uFF1A".concat(_this3.withdrawFeeObj.admin_id),
                    operation_id: 'pc_agent_withdraw_fee_1'
                  }).then(function (res) {
                    _this3.$message({
                      message: '提现手续费设置成功',
                      type: 'success'
                    });
                  });
                }
              });
            }
            _this3.$message({
              message: '提交成功',
              type: 'success'
            });
            history.back();
          }).catch(function (err) {
            setTimeout(function () {
              _this3.clickSubmit = false;
            }, 1000);
          });
        } else {
          _this3.clickSubmit = false;
        }
      });
    },
    /**
     * 选择区域
     */
    selectCity: function selectCity(e) {
      this.form.province = e.province.value;
      this.form.city = e.city.value;
      this.form.county = e.area.value;
    },
    /**
     * 判断提现手续费配置是否有变动
     */
    isWithdrawFeeChanged: function isWithdrawFeeChanged() {
      var current = this.withdrawFeeObj;
      var original = this.originalWithdrawFeeObj;
      return current.config_mode !== original.config_mode || current.withdraw_rate !== original.withdraw_rate || current.withdraw_amount !== original.withdraw_amount;
    }
  }
};